/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Expected_DeliveryInputs */

const en_inbound_field_expected_delivery = /** @type {(inputs: Inbound_Field_Expected_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected delivery`)
};

/**
* | output |
* | --- |
* | "Expected delivery" |
*
* @param {Inbound_Field_Expected_DeliveryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_expected_delivery = /** @type {((inputs?: Inbound_Field_Expected_DeliveryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Expected_DeliveryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_expected_delivery(inputs)
});